<template>
  <component
    :is="(event.external_url ?? event.slug) ? NuxtLink : 'div'"
    :to="event.external_url ?? localePath({name: 'events-slug', params: {slug: event.slug}})"
    rel="noopener noreferrer nofollow"
    class="link-escape group"
  >
    <div class="date text-green-darkest pb-1 font-bold">
      {{ formatDate(new Date(event.start_date), 'dd MMMM yyyy') }}
    </div>
    <div
      class="text-xl font-bold text-black lg:text-2xl lg:transition-transform lg:duration-300 lg:group-hover:translate-x-4"
    >
      {{ event.title }}
    </div>
  </component>
</template>

<script setup lang="ts">
import type {EventsQuery} from '~/graphql/graphql';
import {NuxtLink} from '#components';
import {useLocalePath} from '#i18n';

defineProps<{
  event: EventsQuery['events'][number];
}>();

const formatDate = useLocaleDate();
const localePath = useLocalePath();
</script>
